import React, { useEffect, useState } from 'react';
import OrderSummary from './OrderSummary.jsx';
import { getMercadoPaymentMessage } from '/Foundation/Common/code/Utils/PaymentUtils.js';
import { useSelector } from 'react-redux';
import { loadPayPalSDK, renderPayPalMessage } from '/Foundation/Common/code/Utils/PayPalMessaging.js';
import { unTabable } from '/Foundation/Common/code/Utils/WcagUtils.js';
const Sidebar = () => {
  const [klarnaIsEnabled, setKlarnaIsEnabled] = useState(false);
  const [mercadoIsEnabled, setMercadoIsEnabled] = useState(false);
  const cart = useSelector((state) => state.Cart);
  const cartPageData = useSelector((state) => state.CartPageData);
  const { total } = cart;

  useEffect(() => {
    let klarnaIsEnabled = cartPageData.klarnaIsEnabled;
    setMercadoIsEnabled(cartPageData.mercadoMessagingIsEnabled);

    if (klarnaIsEnabled) {
      const script = document.createElement('script');

      script.src = cartPageData.klarnaOnSiteMessagingScriptUrl;
      script.async = true;
      script.dataset.environment = window._THULEDATA._Cart.klarnaEnvironment;
      script.dataset.clientId = cartPageData.klarnaOnSiteMessagingClientId;

      document.body.insertBefore(script, document.body.firstChild);

      setKlarnaIsEnabled(true);
    }
  }, []);

  useEffect(() => {
    if (window.KlarnaOnsiteService && window.Klarna?.OnsiteMessaging) window.Klarna?.OnsiteMessaging?.refresh();

    if (mercadoIsEnabled && total > 0) showMercadoMessage(total);

    // Handle PayPal messaging rendering when cart opens/updates
    if (cartPageData.paypalMessagingIsEnabled && total >= 30 && total <= 2000) {
      const config = {
        clientId: cartPageData.paypalClientId,
        currency: window._THULEDATA?.currencyCode,
        baseURL: cartPageData.paypalMessagingBaseURL,
      };
      loadPayPalSDK(config).then(() => {
        renderPayPalMessage({
          selector: '.paypal-messaging-cart',
          amount: total,
          placement: 'cart',
          buyerCountry: cartPageData.marketCode,
        });
      });
    }
  }, [total, mercadoIsEnabled, klarnaIsEnabled]);

  const showMercadoMessage = (total) => {
    const mercadoBaseURL = cartPageData.mercadoAPIBaseURL;
    const mercadoAPIKey = cartPageData.mercadoAPIKey;
    getMercadoPaymentMessage(mercadoBaseURL, mercadoAPIKey, total);
  };

  return (
    <div className="sidebar px-6">
      <div className="sidebar-panel">
        <div className="panel-content">
          <OrderSummary />
          {klarnaIsEnabled && total > 0 && (
            <klarna-placement
              data-key="credit-promotion-auto-size"
              data-locale={window._THULEDATA.SitecoreLanguage}
              data-purchase-amount={Math.round(total * 100)}
            ></klarna-placement>
          )}
          {mercadoIsEnabled && total > 0 && <div className="mercado-messaging mb-8"></div>}
          {cartPageData.paypalMessagingIsEnabled && total >= 30 && total <= 2000 && (
            <div className="paypal-messaging paypal-messaging-cart pb-8"></div>
          )}
          <div className="payment-logos d-flex">
            {cartPageData.paymentMethodImages.map((logo) => (
              <img key={logo.altText} src={logo.logoUrl} alt={logo.altText} className="me-3" />
            ))}
          </div>

          {cartPageData.needHelp && (
            <div className="sidebar-section need-help mt-9" data-component-label="Cart links">
              <h5 className="heading5">{cartPageData.orderInformation}</h5>
              {Object.entries(cartPageData.needHelp)?.map(([key, value], index) => (
                <a href={value} className="paragraph--s" key={index} tabIndex={unTabable(!cart.miniCartIsOpen)}>
                  {key}
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
